import NavBar from '../../components/NavBar'

export default function Home(props) {
  return (
    <NavBar title='單一入口'></NavBar>
  )
}